@let currentItem = item();

<big-ui-link
    class="block"
    [linkClass]="'none after:absolute after:inset-0 after:content-[\'\'] after:z-10'"
    [href]="currentItem.url">
    <div>
        @if (currentItem.type === 'big_form') {
            <div class="text-primary dark:text-white">{{ simplyFillOutOnlineTranslation() }}</div>
        }

        <h2 class="h5 mt-0 mb-2 flex">
            {{ currentItem.title }}

            @if (isPrivateUrl()) {
                <span class="ml-2 w-5">
                    <big-icon
                        [icon]="myBigIcon"
                        [size]="'w-5'"
                        class="fill-current" />
                </span>
            }
        </h2>

        <p
            class="mb-0 font-sans"
            [innerHTML]="currentItem.body | highlight: highlightString()"></p>
    </div>
</big-ui-link>

@if (currentItem.breadcrumb.length > 0) {
    <big-ui-breadcrumb
        class="mt-2 font-sans text-current relative z-11"
        [entries]="currentItem.breadcrumb" />
}
